import classNames from 'classnames';
import * as React from 'react';
import { Logo, WhiteLogo } from '../Icons';

export interface Props {
  color?: string;
  text?: string;
  relative?: boolean;
  button?: boolean;
  loadMore?: boolean;
  isWhite?: boolean;
}

export const Spinner = (props: Props) =>
  props.relative ? (
    <div
      className={classNames('loading', {
        relative: props.relative,
      })}
    >
      <div className={'wrapper'}>
        <div className={'loader'}>
          <svg version='1.1' id='loader-1' x='0px' y='0px' viewBox='0 0 50 50'>
            <path d='M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z'>
              <animateTransform
                attributeType='xml'
                attributeName='transform'
                type='rotate'
                from='0 25 25'
                to='360 25 25'
                dur='0.8s'
                repeatCount='indefinite'
              />
            </path>
          </svg>
        </div>
        <div className={'logo'}>
          <Logo />
        </div>
        <p>{props.text}</p>
      </div>
    </div>
  ) : (
    <div
      className={classNames('loading', {
        relative: props.relative,
      })}
    >
      <div className={'wrapper'}>
        <div className={'loader'}>
          <svg version='1.1' id='loader-1' x='0px' y='0px' viewBox='0 0 50 50'>
            <path d='M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z'>
              <animateTransform
                attributeType='xml'
                attributeName='transform'
                type='rotate'
                from='0 25 25'
                to='360 25 25'
                dur='0.8s'
                repeatCount='indefinite'
              />
            </path>
          </svg>
        </div>
        <div className={'logo'}>{props.isWhite ? <WhiteLogo /> : <Logo />}</div>
        <p>{props.text}</p>
      </div>
    </div>
  );
